<template>
  <div class="container-fluid basic-background">
    <div class="row">
      <div class="col-md-12">
        <div class="px-3 py-4 px-md-5 py-md-5 block-card user-manage">
          <div class="d-flex justify-content-between align-items-center mb-4">
            <h1 class="h5">{{ $t("userManagement") }}</h1>
            <button class="btn block-btn block-btn-hover" @click="showAddUserSection">
              {{ $t("addUser") }}
            </button>
          </div>

          <!-- 使用者清單表格 -->
          <div class="table-responsive">
            <table class="table table-striped align-middle">
              <thead>
                <tr>
                  <th scope="col">{{ $t("user") }}</th>
                  <th scope="col" class="text-center">
                    {{ $t("train") }}
                  </th>
                  <th scope="col" class="text-center">
                    {{ $t("inference") }}
                  </th>
                  <th scope="col" class="text-center">
                    {{ $t("annotate") }}
                  </th>
                  <th scope="col" class="text-center">
                    {{ $t("manage") }}
                  </th>
                  <th scope="col" class="text-center">
                    {{ $t("actions") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="user in users" :key="user.id">
                  <td>{{ user.name }}</td>
                  <td class="text-center">
                    <i :class="user.enable_train ? 'bi bi-check-lg text-secondary' : 'bi bi-x-lg text-secondary'" />
                  </td>
                  <td class="text-center">
                    <i :class="user.enable_inference ? 'bi bi-check-lg text-secondary' : 'bi bi-x-lg text-secondary'" />
                  </td>
                  <td class="text-center">
                    <i :class="user.enable_annotation ? 'bi bi-check-lg text-secondary' : 'bi bi-x-lg text-secondary'" />
                  </td>
                  <td class="text-center">
                    <i :class="user.enable_user_manage ? 'bi bi-check-lg text-secondary' : 'bi bi-x-lg text-secondary'" />
                  </td>
                  <td class="text-center">
                    <button class="btn btn-sm btn-danger" @click="onDeleteUser(user.id)" :aria-label="$t('delete')">
                      <i class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div 
    id="add-user-section" 
    class="container-fluid basic-background add-user-section"
    v-show="isAddUserSectionVisible"
  >
    <div class="row">
      <div class="col-md-12">
        <div class="mb-4 px-3 py-4 px-md-5 py-md-5 block-card">
          <div class="d-flex justify-content-between align-items-center">
            <h5>{{ $t("addUser") }}</h5>
            <div id="add-user-buttons" class="d-none d-md-flex">
              <button
                type="button"
                class="btn block-btn custom-cancel-btn"
                @click="hideAddUserSection"
              >
                {{ $t("cancel") }}
              </button>
              <button 
                type="button" 
                class="btn block-btn block-btn-hover"
                :disabled="!newUser.username || !newUser.password"
                @click="onAddUser"
              >
                {{ $t("addConfirm") }}
              </button>
            </div>
          </div>
        </div>

        <div class="px-3 py-4 px-md-5 py-md-5 block-card">
          <div class="form-group">
            <label class="form-label"  for="new-user-username">{{ $t("userAccount") }}</label>
            <input
              id="new-user-username"
              v-model="newUser.username"
              type="text"
              class="form-control custom-input"
              @blur="usernameTouched = true"
              required
            >
            <div v-if="!newUser.username && usernameTouched " class="text-danger small">{{ $t("accountNoEmpty") }}</div>
          </div>
          
          <div class="form-group">
            <label class="form-label" for="new-user-password">{{ $t("passwordLabel") }}</label>
            <input
              id="new-user-password"
              v-model="newUser.password"
              type="password"
              class="form-control custom-input"
              @blur="passwordTouched = true"
              required
            >
            <div v-if="!newUser.password && passwordTouched " class="text-danger small">{{ $t("passwordRequiredMsg") }}</div>
          </div>
          
          <div class="permissions-section">
            <fieldset class="permissions-group">
              <legend class="section-label">{{ $t("permissionSetting") }}</legend>
              <div class="permissions-group">
                <div class="permission-item">
                  <input
                    id="permTrain"
                    v-model="newUser.enable_train"
                    class="custom-checkbox"
                    type="checkbox"
                  >
                  <label class="permission-label" for="permTrain">{{ $t("train") }}</label>
                </div>
                
                <div class="permission-item">
                  <input
                    id="permInference"
                    v-model="newUser.enable_inference"
                    class="custom-checkbox"
                    type="checkbox"
                  >
                  <label class="permission-label" for="permInference">{{ $t("inference") }}</label>
                </div>
                
                <div class="permission-item">
                  <input
                    id="permAnnotation"
                    v-model="newUser.enable_annotation"
                    class="custom-checkbox"
                    type="checkbox"
                  >
                  <label class="permission-label" for="permAnnotation">{{ $t("annotate") }}</label>
                </div>
                
                <div class="permission-item">
                  <input
                    id="permManage"
                    v-model="newUser.enable_user_manage"
                    class="custom-checkbox"
                    type="checkbox"
                  >
                  <label class="permission-label" for="permManage">{{ $t("manage") }}</label>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        
        <div class="mobile-buttons d-md-none">
          <button
            type="button"
            class="btn block-btn custom-cancel-btn"
            @click="hideAddUserSection"
          >
            {{ $t("cancel") }}
          </button>
          <button 
            type="button" 
            class="btn block-btn custom-confirm-btn"
            :disabled="!newUser.username || !newUser.password"
            @click="onAddUser"
          >
            {{ $t("addConfirm") }}
          </button>
        </div>

      </div>
    </div>
  </div>
  
  <!-- Success Modal -->
  <div
    id="successModal"
    class="modal fade"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ $t("info") }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>
        <div class="modal-body">
          <p>{{ successMessage }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            {{ $t("ok") }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Confirm Delete Modal -->
  <div
    id="confirmModal"
    class="modal fade"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Confirm Delete
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>
        <div class="modal-body">
          <p>{{ $t("confirmDeleteText") }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            {{ $t("cancel") }}
          </button>
          <button id="confirmDelete" type="button" class="btn btn-danger">
            {{ $t("delete") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/axios';
import * as bootstrap from 'bootstrap'
import config from '@/config.json'

export default {
  name: 'UserManage',
  data() {
    return {
      users: [],
      newUser: {
        username: '',
        password: '',
        enable_train: false,
        enable_inference: false,
        enable_annotation: false,
        enable_user_manage: false
      },
      addUserError: '',
      successMessage: '',
      usernameTouched: false,
      passwordTouched: false,
      isAddUserSectionVisible: false // 新增控制變數
    }
  },
  mounted() {
    this.fetchUsers()
  },
  methods: {
    async fetchUsers() {
      try {
        const res = await api.get(`${config.apiBaseUrl}/api/annotations/users`)
        this.users = res.data
      } catch (err) {
        console.error('Fetch users failed', err)
      }
    },
    // 修改：顯示 add-user-section
    showAddUserSection() {
      this.addUserError = ''
      this.isAddUserSectionVisible = true
      // 重置表單狀態
      this.usernameTouched = false
      this.passwordTouched = false
    },
    // 新增：隱藏 add-user-section
    hideAddUserSection() {
      this.isAddUserSectionVisible = false
      // 重置表單資料
      this.newUser = {
        username: '',
        password: '',
        enable_train: false,
        enable_inference: false,
        enable_annotation: false,
        enable_user_manage: false
      }
      this.usernameTouched = false
      this.passwordTouched = false
    },
    openSuccessModal(message) {
      this.successMessage = message
      const modalEl = document.getElementById('successModal')
      new bootstrap.Modal(modalEl).show()
    },
    async onAddUser() {
      if (this.users.find(u => u.name === this.newUser.username)) {
        this.addUserError = this.$t('userAlreadyExist')
        this.openSuccessModal(this.addUserError)
        return
      }
      try {
        await api.post(`${config.apiBaseUrl}/api/annotations/createUser`, this.newUser)
        // 修改：隱藏 add-user-section 而非關閉 modal
        this.hideAddUserSection()
        this.fetchUsers()
        this.openSuccessModal(this.$t('userAddSuccess'))
      } catch (err) {
        if (err.response && err.response.status === 400){
          this.addUserError = err.response.data.error || this.$t('userAlreadyExis')
        } else {
          this.addUserError = this.$t('userAddFail')
        }
        this.openSuccessModal(this.addUserError)
      }
    },
    async onDeleteUser(id) {
      const confirmModalEl = document.getElementById('confirmModal')
      const confirmModal = new bootstrap.Modal(confirmModalEl)
      confirmModal.show()

      confirmModalEl.querySelector('#confirmDelete').onclick = async () => {
        confirmModal.hide()
        try {
          await api.post(`${config.apiBaseUrl}/api/annotations/deleteUser`, { username: this.users.find(u => u.id === id).name })
          this.fetchUsers()
          this.openSuccessModal(this.$t('userDeleteSuccess'))
        } catch (err) {
          this.openSuccessModal(this.$t('userDeleteFail'))
        }
      }
    }
  }
}
</script>

<style scoped>
.user-manage th, .user-manage td {
  padding: 5px 15px 5px 0;
  color: #5d5d5d;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 1.95px;
  white-space: nowrap;
}

.add-user-section {
  position: absolute;
  top: 0;
  left: 0;
}

.mobile-buttons {
  display: flex;
  justify-content: center;
  margin: 15px 0;
}

.form-check {
  padding-top: 0.375rem;
}

.custom-modal-content {
  border: none;
  border-radius: 25px;
  background-color: #fff;
}

.custom-modal-header {
  border-bottom: none;
  padding: 30px 30px 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.custom-modal-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.modal-actions {
  display: flex;
  gap: 10px;
}

.custom-cancel-btn {
  background-color: #e0e0e0;
  border: 1px solid #e0e0e0;
  color: #666;
  margin-right: 15px;
  transition: all 0.2s ease;
}

.custom-cancel-btn:hover {
  background-color: #e0e0e0;
  border: 1px solid #e0e0e0;
  color: #666;
}

.custom-confirm-btn {
  background-color: #000;
  color: white;
  border: none;
  transition: all 0.2s ease;
}

.custom-confirm-btn:hover:not(:disabled) {
  background-color: #333;
}

.custom-confirm-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.custom-modal-body {
  padding: 30px;
  padding-top: 20px;
}

.form-group {
  margin-bottom: 25px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-size: 0.95rem;
  font-weight: 500;
}

.custom-input {
  width: 100%;
  height: 45px;
  padding: 5px 16px;
  border: 1px solid #ddd;
  border-radius: 25px;
  font-size: 0.95rem;
  background-color: white;
  transition: all 0.2s ease;
}

.custom-input:focus {
  outline: none;
  border-color: #333;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.permissions-section {
  margin-top: 30px;
}

.section-label {
  display: block;
  margin-bottom: 15px;
  color: #333;
  font-size: 0.95rem;
  font-weight: 500;
}

.permissions-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-start;
}

.permission-item {
  display: flex;
  align-items: center;
  justify-content: center;
  /* 移除內部 padding */
  border: 2px solid #e0e0e0;
  border-radius: 25px;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 155px;
  flex: 0 0 auto;
}

.permission-item:hover {
  border-color: #ccc;
}

.permission-item.active {
  background-color: #000;
  border-color: #000;
}

.custom-checkbox {
  display: none;
}

.permission-label {
  color: #666;
  font-size: 0.9rem;
  cursor: pointer;
  margin: 0;
  text-align: center;
  white-space: nowrap;
  /* 加入 padding 和寬度控制 */
  padding: 12px 16px;
  width: 100%;
  display: block;
}

.permission-label.active {
  color: white;
}

.permission-item:has(.custom-checkbox:checked) {
  background-color: #000;
  border-color: #000;
}

.permission-item:has(.custom-checkbox:checked) .permission-label {
  color: white;
}

@media (max-width: 768px) {
  .custom-modal-header {
    flex-direction: column;
    align-items: center;
    gap: 15px;
    text-align: center;
  }
  
  .permissions-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
  .permission-item {
    width: 100%;
    min-width: auto;
  }

  .custom-modal-body {
    padding: 20px;
  }
}
</style>